// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"ecf663c2","427":"5237c208"}[chunkId] + ".chunk.css";
};